import { bbVars } from './configuration';
import { bBGET, bBPOST, bBPUT, bBInterceptor } from './http';
import { onMessageReceived } from './pay';

function bbGetUrlBase() {
    var bbFlywireScript = document.querySelector("script[src*='bbmercadopago.js']");
    var url = !!bbFlywireScript ? bbFlywireScript.src : '';
    if (!!url) {
        const baseuri = url.split('js');
        bbVars.bbUrlBase = baseuri[0];
    } else {
        bbFlywireScript = document.querySelector("script[src*='bbmercadopago.min.js']");
        url = !!bbFlywireScript ? bbFlywireScript.src : '';
        if (!!url) {
            const baseuri = url.split('js');
            bbVars.bbUrlBase = baseuri[0];
        } else {
            console.log('The bbmercadopago.js script does not exist in the page');
        }
    }
}

function bbUnloadIframe() {
    var loadSubscribe = document.getElementsByTagName("body");
    var substack = document.getElementById("bb-mp-iframe-pay");
    if (substack) {
        loadSubscribe[0].removeChild(substack);
    }
}

function bbLoadScript() {
    var myScript = document.querySelector("script[src*='sdk.mercadopago.com']");
    if (!myScript) {
        var url = bbVars.bbMercadoPagoUrlLib;
        bbCreateScript(url, 'bbMercadoPagoUrlLib', bbOnloadEvoCallback, null)
    }
};

function bbCreateScript(source, id, onloadCb, attrs) {
    let node = document.createElement('script');
    node.src = source;
    node.type = 'text/javascript';
    node.charset = 'utf-8';
    node.async = true;
    node.setAttribute('id', id);
    if (onloadCb) {
        node.onload = onloadCb();
    }
    if (attrs) {
        attrs.forEach(data => {
            node.setAttribute(data.attribute, data.value)
        });
    }
    injectNode(node);
}

function injectNode(node) {
    let refNode = document.querySelector("script[src*='bankbridge.js']");
    if (!refNode) {
        refNode = document.querySelector("script[src*='bankbridge.min.js']")
    }
    if (!refNode) {
        console.log('The bankbridge.js script does not exist in the page');
        return;
    }
    document.getElementsByTagName('head')[0].insertBefore(node, refNode);
}

function bbOnloadEvoCallback() {
    let hola = true;
}

let showCheckout = () => {
    bBGET(`api/MercadoPago/Mode/${bbVars.bbOrderId}`).subscribe({
        next: response => {
            if (response) {
                if (response.mode == bbVars.mpModeEnum.Modal) {
                    bbLoadModal();
                } else if (response.mode == bbVars.mpModeEnum.Redirect) {
                    bbLoadIframe();
                } else {
                    bbLoadIframe();
                }
            }
        },
        error: error => {}
    });
}

function bbLoadModal() {
    const windowFeatures = 'popup=yes,width=900,height=650,left=100,top=100';
    const url = bbVars.bbUrlBase + 'MercadoPago/' + bbVars.bbOrderId + '/pay';
    bbVars.mPMadalRef = window.open(url, '_blank', windowFeatures);
    if (bbVars.mPMadalRef != null) {
        bbVars.mPMadalRef.focus();
        var message = {
            origin: 'ClientWebPage',
            message: 'BBMP_CONFIG_DATA',
            data: bbVars.bbfConfig
        };
        console.log('bbLoadModal: ', bbVars.mPMadalRef);

        try {
            var timeoutRef = setTimeout(() => {
                bbVars.mPMadalRef.postMessage(message, "*");
                bbVars.mPMadalRef.addEventListener('unload', () => {
                    if (bbVars.mPMadalRef && bbVars.mPMadalRef.opener) {
                        bbVars.mPMadalRef.opener.postMessage({
                            action: 'bbMPclose',
                            data: null
                        }, "*");
                    }
                });
                if (timeoutRef) {
                    clearTimeout(timeoutRef);
                }
            }, 2000);
        } catch (e) {
            isWindowClosed();
        }

    } else {
        if (window.confirm('Habilita las ventanas emergentes en el navegador, y haz clic en aceptar para reintentar el pago.')) {
            bbLoadModal();
        }
    }
}

function bbCloseModal() {
    console.log('bbCloseModal: ', bbVars.mPMadalRef);
    if (bbVars.mPMadalRef) {
        bbVars.mPMadalRef.close();
        bbVars.mPMadalRef = null;
    }
}

let isWindowClosed = () => {
    bbVars.timeoutRef = setInterval(isClosed, 2500);
}

let isClosed = () => {
    if (!bbVars.mPMadalRef) {
        clearInterval(bbVars.timeoutRef);
        onMessageReceived({
            action: 'bbMPclose',
            data: null
        });
    }
}

let bbLoadIframe = () => {
    const style = document.createElement('style');
    style.innerHTML = `
		.bb-payment-iframe-pay {
			width: 100%;
			height: 100%;
			background: #fff;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 999999;
			overflow: hidden;
		}
    `;
    document.head.appendChild(style);

    let styleProps = {
        'width': '100%',
        'height': '100%',
        'background': '#fff',
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'z-index': 999999,
        'overflow': 'hidden'
    }

    var substack = document.createElement("iframe");
    substack.src = bbVars.bbUrlBase + 'MercadoPago/' + bbVars.bbOrderId + '/pay'
    substack.classList.add('bb-payment-iframe-pay');
    substack.id = 'bb-mp-iframe-pay';

    for (const property in styleProps)
        substack.style[property] = styleProps[property];

    var loadSubscribe = document.getElementsByTagName("body");
    loadSubscribe[0].appendChild(substack);


    var message = {
        origin: 'ClientWebPage',
        message: 'BBMP_CONFIG_DATA',
        data: bbVars.bbfConfig
    };
    setTimeout(() => substack.contentWindow.postMessage(message, "*"), 2000);
}

export { bbGetUrlBase, bbLoadScript, bbLoadModal as bbLoadIframe, bbUnloadIframe, showCheckout, bbCloseModal };